// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1___0e3b8e0fee7b2d31580","cls2":"NewsHeader-cls2___6096dfefb063925781e NewsHeader-cls1___0e3b8e0fee7b2d31580"};